import { Text } from '@react-spectrum/s2';
import Sparkles from '@react-spectrum/s2/illustrations/linear/Sparkles';
import {
	iconStyle,
	style,
} from '@react-spectrum/s2/style' with { type: 'macro' };
import type { ReactNode } from 'react';

import { MessageFrame } from './MessageFrame';

interface EmptyMessageProps {
	content: string;
	children?: ReactNode;
}

export const EmptyMessage = ({ content, children }: EmptyMessageProps) => {
	return (
		<MessageFrame>
			<div className="flex items-start gap-4">
				<Sparkles styles={iconStyle({ size: 'M' })} />
				<div className="flex flex-col">
					<Text
						styles={style({
							font: 'body',
							fontSize: 'body',
							color: 'body',
						})}
					>
						{content}
					</Text>
					{children}
				</div>
			</div>
		</MessageFrame>
	);
};
